






import Component from 'vue-class-component';
import { MeterFormModel } from '@/context/meter/model/form/MeterFormModel';
import MeterUpdateForm from '@/context/meter/component/form/MeterUpdateForm.vue';
import { FormContainer } from '@/common/mixin/FormContainer';
import { meterApi } from '@/context/meter/api/MeterApi';

@Component({
  components: {
    MeterUpdateForm
  }
})
export default class UpdateMeterPage extends FormContainer<MeterFormModel> {
  model: MeterFormModel = new MeterFormModel();
  id: number = Number(this?.$route?.params?.id);

  async formApi(): Promise<MeterFormModel> {
    const response: MeterFormModel = await meterApi.form<MeterFormModel>(MeterFormModel, { id: this.id });
    return response;
  }
}
